export enum AceInvolvementTypeEnum {
  FOR_VISIBILITY_ONLY = 'For Visibility Only',
  CO_SELL = 'Co-Sell',
}
